import { useGetReleaseId } from '../api/release-api/release-api';
import { ReleaseDto } from '../api/model';

export const useProjectReleases = (projectId?: number) => {
  return useGetReleaseId(projectId!, {
    query: {
      enabled: !!projectId,
      staleTime: 0,
      refetchOnMount: true,
      gcTime: 10 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  });
};